import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { MESSAGE_KEYWORD, useHandleApp } from '@/modules/wello-app';

export type HapticStyle =
  'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' | 'selection';

export const useHaptic = () => {
  const { isWelloApp } = useCheckWelloApp();
  const { request: requestAppHaptic } = useHandleApp({
    type: MESSAGE_KEYWORD.HAPTIC,
  });

  //* 구버전 앱은 params를 무시하고 Light로 동작한다
  const triggerHaptic = (style: HapticStyle = 'light') => {
    if (isWelloApp) {
      requestAppHaptic({ style });
    } else {
      navigator.vibrate?.(10);
    }
  };

  return { triggerHaptic };
};
